import httpManager from "@/app/shared/utils/httpManager";

/**
 * Guarda en una sola operacion las opciones pendientes de los campos de plantilla.
 *
 * @param {number} portfolioId Identificador de la campana.
 * @param {Object} optionsByField Opciones agrupadas por nombre tecnico de campo.
 *
 * @return {Promise<Object>} Resultado del guardado masivo.
 */
export async function saveTemplateFieldOptions(portfolioId, optionsByField) {
  const response = await httpManager.put(
    `/portfolios/${portfolioId}/template/options/`,
    optionsByField
  );

  return response?.data;
}
